import * as React from "react";
import { forwardRef } from "react";
const SvgBigArrowTop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 13, viewBox: "0 0 10 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.00635 6.01172L5.00435 2.01172L9.00635 6.01172", stroke: "#2B2B2B", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.00635 2.01172L5.00635 12.0117", stroke: "#2B2B2B", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgBigArrowTop);
export default ForwardRef;
